import React from 'react';

/**
 * Segmented switch for a status filter or a two-way status field (Staff,
 * Clients & Entities). `options` = [{key, label, count?}]; a count renders as
 * a small tally after the label. Its height matches `inputCls`, so it sits in
 * a toolbar row or a form grid next to inputs.
 *   <SegmentedSwitch ariaLabel="Relationship" options={opts} value={v} onChange={setV} />
 */
const SegmentedSwitch = ({ options, value, onChange, ariaLabel }) => (
  <div role="group" aria-label={ariaLabel} className="inline-flex shrink-0 rounded-lg border border-slate-200 bg-slate-100 p-1">
    {options.map((o) => {
      const on = value === o.key;
      return (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.key)}
          aria-pressed={on}
          className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            on ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'
          }`}
        >
          {o.label}
          {o.count !== undefined && o.count !== null && (
            <span className={`text-xs tabular-nums ${on ? 'text-slate-500' : 'text-slate-400'}`}>{o.count}</span>
          )}
        </button>
      );
    })}
  </div>
);

export default SegmentedSwitch;
